export default /* GraphQL */ `
  query Category($model: String!, $brand: Int!) {
    categories(model:$model, brand:$brand) {
      name
      topics {
        buttonText
        sort
        stepId
        title
        topicImage
      }
    }
  }`;



// WEBPACK FOOTER //
// ./src/utils/results/resultsQuery.js